<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Markt-Segmente</p>

      <h2 class="presentation-page__title">In welchen Märkten wir operieren</h2>

      <p class="presentation-page__text">
        Sechs klar abgegrenzte Geschäftsfelder — von der Privatanlage bis zum
        Multi-MW-Speicherprojekt.
      </p>

      <div class="presentation-page__highlights">
        <article
          v-for="segment in segments"
          :key="segment.title"
          class="presentation-page__segment-card"
        >
          <div
            :class="[
              'presentation-page__segment-icon',
              `presentation-page__segment-icon--${segment.accent}`,
            ]"
            aria-hidden="true"
          >
            <i :class="['fa', segment.icon]"></i>
          </div>

          <div>
            <h3 class="presentation-page__segment-title">{{ segment.title }}</h3>
            <p class="presentation-page__segment-text">{{ segment.text }}</p>
          </div>
        </article>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage11',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      segments: [
        {
          accent: 'brand-primary',
          icon: 'fa-home',
          title: 'B2C',
          text: 'Private Haus- und Mehrfamilienanlagen für Eigenheimbesitzer.',
        },
        {
          accent: 'brand-teal',
          icon: 'fa-industry',
          title: 'B2B',
          text: 'Gewerbe-, Industrie- und Wohnanlagen ab 100 kWp.',
        },
        {
          accent: 'brand-primary',
          icon: 'fa-map',
          title: 'Freiflächenanlagen',
          text: 'Großflächige PV-Anlagen für Investoren und Energieversorger.',
        },
        {
          accent: 'brand-teal',
          icon: 'fa-users',
          title: 'Mieterstromsystem',
          text: 'Direktvermarktung an Endkunden in Wohn- und Gewerbeimmobilien.',
        },
        {
          accent: 'brand-primary',
          icon: 'fa-percent',
          title: 'IAB-Investitionsmodelle',
          text: 'Steueroptimierte Investitionen für Privatanleger nach §7g EStG.',
        },
        {
          accent: 'brand-teal',
          icon: 'fa-flash',
          title: 'BESS-Systeme',
          text: 'Batteriespeicher mit und ohne PV-Anbindung — Grün- und Graustrom.',
        },
      ],
    };
  },
};
</script>
